import { initNav } from "./components/nav";
import { initSearchModal } from "./components/search-modal";
import { initCookiesBanner } from "./components/cookies-banner";

const run = () => {
  try {
    initNav();
  } catch (e) {
    // Fail silently in case nav is not present on the page
  }

  try {
    initSearchModal();
  } catch (e) {
    // Fail silently in case modal is not present on the page
  }

  try {
    initCookiesBanner();
  } catch (e) {
    // Fail silently in case banner is not present on the page
  }
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", run);
} else {
  run();
}
